<template>
  <div class="sc-message--file" :style="colors[message.direction || 'received']">
    <div class="sc-message--file-icon" v-if="message.data.type === 'image'">
      <img :src="message.data.url" class="sc-image" />
    </div>
    <div
      class="sc-message--file-audio"
      v-else-if="message.data.type === 'audio'"
    >
      <audio controls>
        <source :src="message.data.url" />
        {{ $t('BrwoserAudio') }}
      </audio>
    </div>
    <div
      class="sc-message--file-video"
      v-else-if="message.data.type === 'video'"
    >
      <video controls width="100%">
        <source :src="message.data.url" />
        {{ $t('BrowserVideo') }}
      </video>
    </div>
    <div
      class="sc-message--file-download"
      :style="colors[message.direction || 'received']"
      v-else-if="message.data.type === 'file'"
    >
      <a
        :href="message.data.url ? message.data.url : '#'"
        target="_blank"
        @click.stop=""
        download
      >
        <img :src="icons.fileIcon" />
        {{ $t('Download') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileMessage',
  inject: {
    colors: {
      type: Object
    },
    icons: {
      type: Object
    }
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.sc-message--file {
  background-color: transparent !important;
  border-radius: 6px;
  font-weight: 300;
  font-size: 14px;
  line-height: 1.4;
  /* white-space: pre-wrap; */
  -webkit-font-smoothing: subpixel-antialiased;

  audio,
  video {
    max-width: 100%;
  }
}

.sc-message--content.sent .sc-message--file {
  word-wrap: break-word;
}

.sc-message--file-icon {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
  margin-bottom: 0px;
}

.sc-image {
  max-width: 100%;
  height: auto;
}

.sc-message--file-download {
  padding: 10px 20px;
  border-radius: 6px;
  color: white;
  text-align: center;

  a {
    text-decoration: none;
    color: #ece7e7;

    img {
      vertical-align: middle;
      width: 24px;
      height: auto;
    }
  }
}

.sc-message--content.received .sc-message--file {
  color: #263238;
  background-color: #f4f7f9;
  margin-right: 40px;
}

.sc-message--content.received .sc-message--file-download {
  color: #000;
}

.sc-message--content.received .sc-message--file a {
  color: rgba(43, 40, 40, 0.7);
}

.sc-message--content.received .sc-message--file a:hover {
  color: #0c0c0c;
}
</style>
